import { render, staticRenderFns } from "./SelectByContactForm.vue?vue&type=template&id=5167e0bf&scoped=true"
import script from "./SelectByContactForm.vue?vue&type=script&lang=ts"
export * from "./SelectByContactForm.vue?vue&type=script&lang=ts"
import style0 from "./SelectByContactForm.vue?vue&type=style&index=0&id=5167e0bf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5167e0bf",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/search/search.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fsearch%2FSelectByContactForm.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports